import React from "react";
import { useLang } from "@/i18n/LanguageContext";
import { api } from "@/lib/api";
import { Star, Quote } from "lucide-react";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";

export default function TestimonialsSection() {
  const { lang, t } = useLang();
  const [items, setItems] = React.useState([]);

  React.useEffect(() => {
    api.get("/testimonials").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  return (
    <section className="py-24 lg:py-32 bg-muted/40 relative overflow-hidden" data-testid="testimonials-section">
      <div className="container-x">
        <header className="max-w-2xl mb-14">
          <p className="overline mb-4">{t("sections.testiOver")}</p>
          <h2 className="font-serif text-4xl lg:text-5xl text-primary tracking-tight">{t("sections.testiTitle")}</h2>
          <p className="mt-5 text-muted-foreground text-lg">{t("sections.testiSub")}</p>
        </header>

        <Carousel opts={{ align: "start", loop: true }}>
          <CarouselContent className="-ml-6">
            {items.map((tst) => (
              <CarouselItem key={tst.id} className="pl-6 md:basis-1/2 lg:basis-1/3" data-testid={`testimonial-${tst.id}`}>
                <div className="bg-card border border-border rounded-lg p-8 h-full flex flex-col gap-5 hover:shadow-lg transition-shadow">
                  <Quote className="h-7 w-7 text-accent" />
                  <p className="text-foreground/85 leading-relaxed italic text-base">
                    "{lang === "id" ? tst.text_id : tst.text_en}"
                  </p>
                  <div className="flex gap-1 mt-auto">
                    {Array.from({ length: tst.rating }).map((_, i) => (
                      <Star key={i} className="h-4 w-4 fill-accent text-accent" />
                    ))}
                  </div>
                  <div className="flex items-center gap-3 pt-4 border-t border-border">
                    {tst.avatar && (
                      <img src={tst.avatar} alt={tst.name} className="h-11 w-11 rounded-full object-cover" />
                    )}
                    <div>
                      <div className="font-serif text-primary">{tst.name}</div>
                      <div className="text-xs text-muted-foreground">{tst.location} · {tst.package}</div>
                    </div>
                  </div>
                </div>
              </CarouselItem>
            ))}
          </CarouselContent>
          <div className="hidden md:block">
            <CarouselPrevious className="bg-card border-border text-primary hover:bg-primary hover:text-white -left-2" />
            <CarouselNext className="bg-card border-border text-primary hover:bg-primary hover:text-white -right-2" />
          </div>
        </Carousel>
      </div>
    </section>
  );
}
